import React from 'react';
import PropTypes from 'prop-types';
import { createGetOptionsFunc } from './extreact-style-params';
var filterOptions = function (styleParams) {
    var requiredOptions = [
        'isRTL',
        'cubeType',
        'cubeImages',
        'cubeRatio',
        'cropRatio',
        'layoutParams_cropRatio',
        'collageAmount',
        'collageDensity',
        'columnsWidth',
        'cropOnlyFill',
        'chooseBestGroup',
        'externalInfoHeight',
        'externalInfoWidth',
        'fixedColumns',
        'groupsPerStrip',
        'galleryMargin',
        'layoutParams_gallerySpacing',
        'groupTypes',
        'groupSize',
        'isVertical',
        'imageMargin',
        'minItemSize',
        'scrollDirection',
        'placeGroupsLtr',
        'rotatingGroupTypes',
        'layoutParams_repeatingGroupTypes',
        'rotatingCropRatios',
        'smartCrop',
        'scatter',
        'smartCrop',
        'targetItemSize',
        'hasThumbnails',
        'thumbnailSize',
        'thumbnailSpacings',
        'galleryThumbnailsAlignment',
        'isSlideshow',
        'galleryLayout',
        'slideshowInfoSize',
        'layoutParams_structure_galleryRatio_value',
    ];
    return Object.keys(styleParams)
        .filter(function (key) { return requiredOptions.indexOf(key) >= 0; })
        .reduce(function (res, key) {
        res[key] = styleParams[key];
        return res;
    }, {});
};
var hashToInt = function (str) {
    if (str === void 0) { str = ''; }
    var int = 0;
    for (var i = 0; i < str.length; i++) {
        int += str.charCodeAt(i);
    }
    return int;
};
function getServerParams(props) {
    var items = props.items, _a = props.rawOptions, rawOptions = _a === void 0 ? props.options : _a, useNativeLayoutFixer = props.useNativeLayoutFixer;
    var optionsStr = Object.entries(filterOptions(rawOptions))
        .map(function (keyVal) { return keyVal.join(':'); })
        .join('|');
    var itemsStr = items
        .slice(0, 20)
        .map(function (item) {
        return "".concat(hashToInt(item.mediaUrl), "_").concat(item.width || item.metaData.width, "_").concat(item.height || item.metaData.height);
    })
        .join('|');
    if (useNativeLayoutFixer) {
        var getOptions = createGetOptionsFunc(rawOptions);
        var hrefStr = "/_serverless/pro-gallery-native-layout-fixer/layoutCssNative?id=".concat(props.id, "&items=").concat(itemsStr, "&container=");
        return { hrefStr: hrefStr, getOptions: getOptions };
    }
    else {
        var hrefStr = "/_serverless/pro-gallery-css-v4-staging-server/layoutCss?ver=2&id=".concat(props.id, "&items=").concat(itemsStr, "&container=");
        return { hrefStr: hrefStr, getOptions: "() => ".concat(JSON.stringify(optionsStr)) };
    }
}
function createSsrJs(props) {
    var useNativeLayoutFixer = props.useNativeLayoutFixer;
    var _a = getServerParams(props), hrefStr = _a.hrefStr, getOptions = _a.getOptions;
    var embed = function (content) { return "\n  var ele = document.getElementById('".concat('pro-gallery-' + props.id, "');\n  ").concat(content, "\n  var isVertical = options.includes('layoutParams_structure_scrollDirection:\"VERTICAL\"');\n  var layoutFixerUrl =  '").concat(hrefStr, "' + pgMeasures.top + '_' + pgMeasures.width + '_' + pgMeasures.height + '_' + window.innerHeight + '&options=' + options;\n  document.getElementById('").concat('layout-fixer-style-' + props.id, "').setAttribute('href', encodeURI(layoutFixerUrl));\n});\n\n  "); };
    if (useNativeLayoutFixer) {
        return embed("\n      var nativeComp = document.getElementById(\"".concat(props.id, "\"), nativeRect = nativeComp.getBoundingClientRect();\n      var pgMeasures = {top: nativeRect.top, width: nativeRect.width, height: Number(getComputedStyle(nativeComp).getPropertyValue(\"height\").replace(\"px\", \"\"))};\n      var options = (").concat(getOptions, ")(ele);\n    "));
    }
    else {
        return embed("\n              var pgMeasures = ele.getBoundingClientRect();\n              var options = (".concat(getOptions, ")(ele);\n    "));
    }
}
export var LayoutFixer = function (props) {
    try {
        return (React.createElement("div", { id: 'layout-fixer-' + props.id + props.isPrerenderMode, key: 'layout-fixer-' + props.id + props.isPrerenderMode, style: { display: 'none' } },
            React.createElement("link", { rel: "stylesheet", id: 'layout-fixer-style-' + props.id }),
            React.createElement("script", { dangerouslySetInnerHTML: {
                    __html: "try {\n            window.requestAnimationFrame(function() {\n              ".concat(createSsrJs(props), "\n        } catch (e) {\n          console.warn('Cannot set layoutFixer css', e);\n        }"),
                } })));
    }
    catch (e) {
        return (React.createElement("div", { id: "layoutFixerErrors", style: { display: 'none' } }, e.toString()));
    }
};
LayoutFixer.propTypes = {
    isPrerenderMode: PropTypes.bool,
    id: PropTypes.string,
    items: PropTypes.array,
    options: PropTypes.object,
    useNativeLayoutFixer: PropTypes.bool,
};
//# sourceMappingURL=layoutFixer.js.map